"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OddFormatDefaultModeDTO = void 0;
var OddFormatDefaultModeDTO;
(function (OddFormatDefaultModeDTO) {
    OddFormatDefaultModeDTO["PotentialWinnings"] = "potential-winnings";
    OddFormatDefaultModeDTO["DecimalOdds"] = "decimal-odds";
    OddFormatDefaultModeDTO["American"] = "american";
    OddFormatDefaultModeDTO["HongKong"] = "hong-kong";
})(OddFormatDefaultModeDTO || (exports.OddFormatDefaultModeDTO = OddFormatDefaultModeDTO = {}));
